export default "__VITE_ASSET__BXaY$$eS__"